import React, { memo } from "react";
import { HStack, VStack } from "@chakra-ui/react";
import colors from "app/colors";
import { MessageThreadType, RelatedMessageThreadFragment } from "gql/graphql";
import { ChatsIcon, CircleCheckIcon, ThreadsIcon } from "modules/icons";
import MessageThreadPreviewSubject from "../message-thread/message-thread-preview-subject";

interface IProps {
  relatedMessageThread: RelatedMessageThreadFragment;
}

const RelatedMessageThread = ({ relatedMessageThread }: IProps) => (
  <HStack>
    <ThreadTypeIcon type={relatedMessageThread.type} />
    <VStack w="full" spacing={0} alignItems="flex-start">
      <MessageThreadPreviewSubject messageThread={relatedMessageThread} />
    </VStack>
  </HStack>
);

const ThreadTypeIcon = ({ type }: { type: MessageThreadType }) => {
  switch (type) {
    case MessageThreadType.Thread: {
      return <ThreadsIcon fill={colors.orange40} boxSize={5} />;
    }
    case MessageThreadType.Chat: {
      return <ChatsIcon fill={colors.blue10} boxSize={5} />;
    }
    case MessageThreadType.Task: {
      return <CircleCheckIcon fill={colors.greenPrimary} boxSize={5} />;
    }
    default: {
      return null;
    }
  }
};

export default memo(RelatedMessageThread);
